import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({
    name: 'mySafeHtml'
})
export class MySafeHtml implements PipeTransform  {

   constructor(private _sanitizer: DomSanitizer) {}

   public transform(v: string): SafeHtml {
      return this._sanitizer.bypassSecurityTrustHtml(v);
   }
}
